<div class="card">
	<div class="card-header">
		<h1>Password SAT <i (click)="edit = null; modalCreate = true;"
				class="fa fa-circle-plus clickeable text-info"></i></h1>
	</div>
	<div class="form-group">
		<label for="search" class="form-label">Buscar empresa </label>
		<input type="text" [(ngModel)]="filterWord" (input)="filterCompany()" autocomplete="off"
			placeholder="Ingresa nombre de empresa" id="search" name="search" class="form-control">
	</div>
	<div class="grid-companies" *ngIf="!gettingData">
		<ng-container *ngFor="let password of companiesPassword">
			<div class="card container-password-sat">
				<div class="card-header">
					<h5>{{password.name}}</h5>
				</div>
				<div class="card-body">
					<i [class.scaling]="password.deletingPasswordSat" (click)="password.deletingPasswordSat = true;"
						class="fa fa-trash text-danger clickeable icon-delete"></i>
					<div class="delete-password-sat" *ngIf="password.deletingPasswordSat">
						<ng-container *ngIf="!deleting[password.id]">
							<span class="h6" style="font-weight: bolder;">¿Estás seguro de eliminar la contraseña?</span>
							<div class="flex">
								<span (click)="deletePasswordSAT(password)" style="font-size:2rem; color: darkred; filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 0.496));" class="clickeable"><i
										class="fa fa-trash"></i>Sí</span>
								<span (click)="password.deletingPasswordSat = false" style="font-size:2rem;filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 0.496));" class="clickeable text-info"><i
										class="fa fa-ban"></i>No</span>
							</div>
						</ng-container>
						<app-loading-animation [height]="'5rem'" *ngIf="deleting[password.id]"></app-loading-animation>
					</div>
					<div class="row">
						<div class="col-sm-4">
							<img src="{{password.logo!=null ? 'https://s3.amazonaws.com/rrhh-images/company/logos/' + password.logo : ''}}"
								alt="" (error)="$event.target.src = '../../../../../assets/img/nophoto.svg'">
						</div>
						<div class="col-sm-8">
							<b>{{password.nit}} - {{password.alphanumericId}}</b>
							<ng-container *ngIf="!password.passwordRequest.edit">
								<div class="input-group">
									<button class="btn btn-primary input-group-text"
										(click)="edit = password; modalCreate = true">
										<i class="fa fa-edit" style="color: white;"></i>
									</button>
									<input type="text" disabled #passwordInput placeholder="******"
										id="p{{password.id}}" name="p{{password.id}}" class="form-control">
									<label (click)="copy(password.passwordSat)" for="password"
										class="input-group-text bg-primary clickeable">
										<i class="fa fa-paste" style="color: white;"></i>
									</label>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
	<app-loading-animation [height]="'10rem'" *ngIf="gettingData"></app-loading-animation>
	<span class="display-5 text-info" style="text-align: center; padding: 2em;"
		*ngIf="companiesPassword.length == 0 && !gettingData"><i class="fa fa-circle-plus"></i>No se encontraron
		contraseñas guardadas</span>
	<app-simple-pagination style="z-index: -1 !important;" [elements]="pagination" [sizes]="sizes"
		(changed)="getPaginationCompaniesPassword()"></app-simple-pagination>
</div>
<app-modal-password-sat *ngIf="modalCreate" [edit]="edit"
	(close)="modalCreate = false; getPaginationCompaniesPassword();"></app-modal-password-sat>